export default {
  MISSING_CRITICAL_DISPLAY: 'missing_critical_display',
  REACHED_REQUIRED_QUESTION: 'reached_required_question',
};
